// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import { Input, InputNumber, Tooltip, Popover, Checkbox } from 'element-ui'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUser,
  faCloudRain,
  faKeyboard,
  faCloudMoonRain,
  faKey,
  faCloudShowersHeavy,
  faCloudSunRain,
  faPooStorm,
  faCloudSun,
  faCloudMoon,
  faShoppingCart,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faPlusCircle,
  faMinusCircle,
  faTimesCircle,
  faSyncAlt,
  faCloudDownloadAlt,
  faSearch,
  faExpand,
  faTruck,
  faCommentDollar,
  faLock,
  faExclamation,
  faMobileAlt,
  faSave
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import Collapse from '@/components/Collapse/Collapse.vue'
import CollapseItem from '@/components/Collapse/CollapseItem.vue'
import BaseDropdown from '@/components/BaseDropdown.vue'
import Card from '@/components/Cards/Card.vue'
import BaseButton from '@/components/BaseButton.vue'
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue'

library.add(
  faUser,
  faCloudRain,
  faKeyboard,
  faCloudMoonRain,
  faKey,
  faCloudShowersHeavy,
  faCloudSunRain,
  faPooStorm,
  faCloudSun,
  faCloudMoon,
  faShoppingCart,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faPlusCircle,
  faMinusCircle,
  faTimesCircle,
  faSyncAlt,
  faCloudDownloadAlt,
  faSearch,
  faExpand,
  faTruck,
  faCommentDollar,
  faLock,
  faExclamation,
  faMobileAlt,
  faSave
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(BaseInput.name, BaseInput)
Vue.component(BaseDropdown.name, BaseDropdown)
Vue.component(Card.name, Card)
Vue.component(BaseCheckbox.name, BaseCheckbox)
Vue.component(BaseButton.name, BaseButton)
Vue.component(Input.name, Input)
Vue.component(Checkbox.name, Checkbox)
Vue.component(InputNumber.name, InputNumber)
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
Vue.use(Tooltip)
Vue.use(Popover)

// storylabs
